import { render, staticRenderFns } from "./TermsAndConditionsPanel.vue?vue&type=template&id=fce5ff12&scoped=true&"
import script from "./TermsAndConditionsPanel.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsPanel.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditionsPanel.vue?vue&type=style&index=0&id=fce5ff12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce5ff12",
  null
  
)

export default component.exports